import { render, staticRenderFns } from "./AddReturns.vue?vue&type=template&id=d4833abc&scoped=true"
import script from "./AddReturns.vue?vue&type=script&lang=js"
export * from "./AddReturns.vue?vue&type=script&lang=js"
import style0 from "./AddReturns.vue?vue&type=style&index=0&id=d4833abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4833abc",
  null
  
)

export default component.exports